import { render, staticRenderFns } from "./ChangeTheme.vue?vue&type=template&id=6fda90bf&scoped=true&"
import script from "./ChangeTheme.vue?vue&type=script&lang=js&"
export * from "./ChangeTheme.vue?vue&type=script&lang=js&"
import style0 from "./ChangeTheme.vue?vue&type=style&index=0&id=6fda90bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fda90bf",
  null
  
)

export default component.exports